import React from 'react';

const TILE_COLORS = ['#7c3aed', '#2563eb', '#0891b2', '#059669', '#d97706', '#dc2626', '#db2777'];

const _hashColor = (label) => {
  let h = 0;
  for (let i = 0; i < label.length; i++) h = ((h << 5) - h + label.charCodeAt(i)) | 0;
  return TILE_COLORS[Math.abs(h) % TILE_COLORS.length];
};

/**
 * Coloured single-letter tile — used as the `fallback` slot for TemplateThumbnail
 * inside designer pages, where every row should still feel branded when a
 * template has neither a stored raster nor renderable canvas JSON.
 */
const LetterTile = ({ label = 'U', textClassName = 'text-white text-lg font-bold select-none' }) => {
  const trimmed = (label || 'U').trim() || 'U';
  const initial = trimmed.charAt(0).toUpperCase();
  const color = _hashColor(trimmed);
  return (
    <div className="absolute inset-0 flex items-center justify-center" style={{ background: color }}>
      <span className={textClassName}>{initial}</span>
    </div>
  );
};

export default LetterTile;
